import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=b8cab5a6&scoped=true&"
import script from "./Framework.vue?vue&type=script&lang=js&"
export * from "./Framework.vue?vue&type=script&lang=js&"
import style0 from "./Framework.vue?vue&type=style&index=0&id=b8cab5a6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cab5a6",
  null
  
)

export default component.exports